<div class="table-responsive">
    <table class="table table-striped table-hover table-bordered" *ngIf="participantes">
        <thead>
            <tr>
                <th class="col-participante">Participante</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let participante of participantes; let i = index" (click)="selectParticipante(participante)">
                <td class="col-participante">
                    {{participante.nome | clienteNome:participante.nomeFantasia:participante.codigoIntegracaoErp}}
                    <small>
                        {{participante.nome | clienteNomeSecundario:participante.nomeFantasia}}
                    </small>
                </td>                            
            </tr>
            <tr *ngIf="participantes?.length === 0" class="no-record">
                <td class="text-center">
                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum participante encontrado
                </td>
            </tr>
        </tbody>
    </table>
</div>